// src/components/common/ViewSwitch.tsx
import { Button } from '@fluentui/react-components';
import { Board20Regular, BuildingMultiple20Regular } from '@fluentui/react-icons';

export default function ViewSwitch({
  isTenant,
  isDashboard,
  onTenant,
  onDashboard,
}: {
  isTenant: boolean;
  isDashboard: boolean;
  onTenant: () => void;
  onDashboard: () => void;
}) {
  return (
    <nav aria-label="Primary view switcher" style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
      <Button
        appearance={isTenant ? 'primary' : 'secondary'}
        size="large"
        icon={<BuildingMultiple20Regular />}
        aria-pressed={isTenant}
        aria-current={isTenant ? 'page' : undefined}
        onClick={onTenant}
      >
        Tenant View
      </Button>
      <Button
        appearance={isDashboard ? 'primary' : 'secondary'}
        size="large"
        icon={<Board20Regular />}
        aria-pressed={isDashboard}
        aria-current={isDashboard ? 'page' : undefined}
        onClick={onDashboard}
      >
        Dashboard
      </Button>
    </nav>
  );
}
